import React from "react";
import { Link } from 'react-router-dom';

export default function SuccessTimelineSection() {
    const timelineCards = [
        {
            title: "ALBANIA",
            subtitle: "WORK VISA",
            imageSrc: "72.png" // আপনার লোকাল ইমেজ পাথ দিন
        },
        {
            title: "ESTONIA",
            subtitle: "WORK PERMIT VISA",
            imageSrc: "73.png"
        },
        {
            title: "KUWAIT",
            subtitle: "WORK PERMIT VISA",
            imageSrc: "74.png"
        },
        {
            title: "DENMARK",
            subtitle: "WORK PERMIT VISA",
            imageSrc: "75.png"
        }
    ];

    return (
        <section
            className="global-area pt-80 pb-80 position-relative overflow-hidden"
            style={{
                backgroundImage: 'url("71.png")', // আগের ব্যাকগ্রাউন্ড ম্যাপ বা নতুন ম্যাপ ইমেজ পাথ
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundColor: '#ffffff'
            }}
        >
            <div className="container px-1 position-relative" style={{ zIndex: 2 }}>
                {/* Section Title & Header */}
                <div className="row mb-5">
                    <div className="col-12">
                        <h2 className="fw-bold mb-2" style={{ color: '#0f172a' }}>Success Timeline</h2>
                        <div className="divider" style={{ width: '50px', height: '4px', backgroundColor: '#2563eb', borderRadius: '2px' }}></div>
                    </div>
                </div>

                {/* 4 Cards Grid */}
                <div className="row g-4 align-items-center justify-content-center mb-5">
                    {timelineCards.map((item, index) => (
                        <div key={index} className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                            <div
                                className="card border-0 text-white text-center position-relative overflow-hidden shadow-sm"
                                style={{
                                    borderRadius: '20px',
                                    height: '220px',
                                    backgroundImage: `url(${item.imageSrc})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                {/* Overlay for better text readability */}
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-end p-3"
                                    style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)' }}
                                >
                                    <h4 className="fw-bold text-white mb-1" style={{ fontSize: '20px', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                                        {item.title}
                                    </h4>
                                    <span className="fw-semibold text-warning" style={{ fontSize: '12px', letterSpacing: '1px' }}>
                                        {item.subtitle}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Highlight Banner / Button Row */}
                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div
                            className="p-3 shadow-sm rounded-pill text-white fw-bold"
                            style={{
                                background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
                                fontSize: '16px',
                                boxShadow: '0 8px 20px rgba(37, 99, 235, 0.2)'
                            }}
                        >
                            22+ years of experience, 10,000+ workers deployed globally.
                        </div>
                        <div className="mt-4">
                            <Link
                                className="btn btn-primary px-4 py-2 rounded-pill fw-semibold shadow-sm"
                                to={'/contact-us'}
                            >
                                CONTACT WITH US <i className={'fa fa-plus ms-1'}></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}